import { CursorClick, Icon, Megaphone, PlusSquare } from '@phosphor-icons/react'
import { HeaderControl } from './control-components/HeaderControl'
import { MarketingConsentControl } from './control-components/MarketingConsentControl'
import { TopBannerControl } from './control-components/TopBannerControl'
import { MilestoneControl } from './control-components/MilestoneControl'
import { FooterControl } from './control-components/FooterControl'
import { PrimaryButtonControl } from './control-components/PrimaryButtonControl'
import { BottomBannerControl } from './control-components/BottomBannerControl'
import { AddOnControl } from './control-components/AddOnControl'
import { OrderSummaryControl } from './control-components/OrderSummaryControl'
import { NotesControl } from './control-components/NotesControl'
import { DiscountControl } from './control-components/DiscountControl'
import { UpsellControl } from './control-components/UpsellControl'

export type CART_ELEMENTS_TYPE =
  | 'HEADER'
  | 'TOP_BANNER'
  | 'MILESTONE'
  | 'FOOTER'
  | 'PRIMARY_BUTTON'
  | 'BOTTOM_BANNER'
  | 'ADD_ON'
  | 'MARKETING_CONSENT'

export type CART_SCROLLABLE_ELEMENTS_TYPE = 'ORDER_SUMMARY' | 'DISCOUNTS' | 'UPSELL' | 'NOTES'

export type BorderSides = 'all' | 'bottom'

export type DISCOUNT_DISPLAY_TYPE = 'INPUT' | 'HIGHLIGHTED'

export const BORDER_SIDES_OPTIONS: Array<{ value: BorderSides; label: string }> = [
  { value: 'all', label: 'All Sides' },
  { value: 'bottom', label: 'Bottom' }
]

export interface ElementStructure {
  type: CART_ELEMENTS_TYPE | CART_SCROLLABLE_ELEMENTS_TYPE
  disabled?: boolean
  title: string
  icon: Icon | string
  component: () => React.JSX.Element
}

export const CART_ELEMENTS: ElementStructure[] = [
  {
    type: 'HEADER',
    title: 'Header',
    icon: 'header_icon',
    component: HeaderControl
  },
  {
    type: 'TOP_BANNER',
    title: 'Top Banner',
    icon: 'top_banner_control',
    component: TopBannerControl
  },
  {
    type: 'MILESTONE',
    title: 'Milestone',
    icon: 'milestone_control',
    component: MilestoneControl
  },
  {
    type: 'FOOTER',
    title: 'Footer',
    icon: 'footer_control',
    component: FooterControl
  },
  {
    type: 'PRIMARY_BUTTON',
    title: 'Primary Button',
    icon: CursorClick,
    component: PrimaryButtonControl
  },
  {
    type: 'BOTTOM_BANNER',
    title: 'Bottom Banner',
    icon: 'bottom_banner_control',
    component: BottomBannerControl
  },
  {
    type: 'ADD_ON',
    title: 'Quick Add-Ons',
    icon: PlusSquare,
    component: AddOnControl
  },
  {
    type: 'MARKETING_CONSENT',
    title: 'Marketing Consent',
    icon: Megaphone,
    component: MarketingConsentControl
  }
]

export const CART_SCROLLABLE_ELEMENTS: Record<CART_SCROLLABLE_ELEMENTS_TYPE, Omit<ElementStructure, 'icon'>> = {
  ORDER_SUMMARY: {
    type: 'ORDER_SUMMARY',
    title: 'Order Summary',
    component: OrderSummaryControl
  },
  DISCOUNTS: {
    type: 'DISCOUNTS',
    title: 'Discounts',
    component: DiscountControl
  },
  UPSELL: {
    type: 'UPSELL',
    title: 'Upsell',
    component: UpsellControl
  },
  NOTES: {
    type: 'NOTES',
    title: 'Notes',
    component: NotesControl
  }
}
